import { Action } from '@ngrx/store';

import { Notification } from './notifications.interface';

export const ADD_NEW_NOTIFICATION = '[Notifications] - Add new notification';
export const DISMISS_NOTIFICATION = '[Notifications] - Dismiss notification';

export class AddNewNotificationAction implements Action {
	public readonly type = ADD_NEW_NOTIFICATION;

	constructor(public payload: Notification) { }
}

export class DismissNotificationAction implements Action {
	public readonly type = DISMISS_NOTIFICATION;

	constructor(public payload: string) { }
}

export type Actions = AddNewNotificationAction | DismissNotificationAction;
